import { Box } from "@mui/material";
import { Sidebar, Topbar } from "../../pages";
import { LayoutProps } from "../../types/interface";
import HelpPopup from "../VisionStudioHelp/index";
import { useState } from "react";
import helpSvg from "../../assets/img/help.svg";
/**
 *
 * Reusable component to Project Layout
 *
 */
const VisionStudioLayout: React.FC<LayoutProps> = ({ children }) => {
  const [isHelpOpen, setIsHelpOpen] = useState(false);

  return (
    <>
      <Sidebar />
      {/*container*/}
      <Box>
        {/*page*/}
        <Box>
          <Topbar />
          {/*Content*/}
          <Box mt="3.125rem">
            <main
              style={{
                flexGrow: 1,
                marginLeft: "4.5rem",
                display: "flex",
                flexDirection: "column",
                width: "calc(100% - 64px)",
                float: "right",
                // overflow: "hidden",
                position: "fixed",
                background: "#F5F6F9",
                height: "calc(100vh - 50px)",
              }}
            >
              {children}
            </main>
          </Box>
        </Box>
      </Box>
      <button
        onClick={() => setIsHelpOpen((prev) => !prev)}
        style={{
          fontFamily: "Inter",
          position: "fixed",
          bottom: "20px",
          left: "10px",
          background: "none",
          color: "#000",
          border: "none",
          padding: "12px",
          //borderRadius: "50%",
          cursor: "pointer",
          fontSize: "0.75rem",
          fontWeight: "400",
          lineHeight: "18px",
          display: "grid",
          zIndex: "9999",
        }}
      >
        <img src={helpSvg} />
        Help
      </button>


      {/* ✅ Help Popup (Controlled by Button) */}
      <HelpPopup isHelpOpen={isHelpOpen} onClose={() => {setIsHelpOpen(false);}} />
    </>
  );
};

export default VisionStudioLayout;
